import './scripts/common';
import './scripts/common-nav';
import {find} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as datepickerRange from '@elements/datepicker-range';
datepickerRange.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({submitOnReset:true,addUrlParams: true});

import * as historyBack from './scripts/history-back';
historyBack.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();

import {createApp} from 'vue';
import BookingQuickfinder from './scripts/components/VueBookingQuickfinder.vue';
const vueApp = createApp({
    components: {
        BookingQuickfinder
    }
})
vueApp.mount('#vue-booking-quickfinder');

import * as wishlist from './scripts/wishlist';
wishlist.init();
wishlist.initInScope(find('body'));

import * as formValidation from '@elements/form-validation';
formValidation.init();